class Http {

    constructor () {
        this._restMethod = ['GET', 'POST', 'PUT', 'DELETE'];
    }

    /**
     * Ajax
     * @param config { type: string, data: {}, url: string, json: boolean }
     * @requires Promise
     * @return {Promise<>}
     */
    ajax(config) {
        if (config.type !== undefined && !this._restMethod.includes(config.type)) {
            return Promise.reject(new Error(`config.type must be GET, POST, PUT or DELETE actually there value is: '${config.type}'`));
        }
        if (config.url === '') {
            return Promise.reject(new Error('config.url must not be empty'));
        }
        if (config.type === 'get' || config.type === 'post') {
            config.type = config.type.toUpperCase();
        }

        let _config = Object.assign({
            type: 'GET',
            data: {},
            url: '',
            json: 'true',
            formData: undefined
        }, config);

        return new Promise(function (resolve, reject) {
            const request = new XMLHttpRequest();

            request.onload  = function () {
                if (request.status === 200) {
                    let response = request.response || request.responseText;
                    if (_config.json) {
                        resolve(JSON.parse(response));
                    } else {
                        resolve(response);
                    }
                } else {
                    reject(request.status + ' ' + request.statusText);
                }
            };
            request.onerror = function () {
                // Also deal with the case when the entire request fails to begin with
                // This is probably a network error, so reject the promise with an appropriate message
                reject('There was a network error.');
            };

            const keys = Object.keys(_config.data);
            let send   = '';

            if (_config.formData === undefined) {
                if (keys.length > 0) {
                    send += `${keys[0]}=${_config.data[keys[0]]}`;
                    for (let i = 1; i < keys.length; i++) {
                        send += `&${keys[i]}=${_config.data[keys[i]]}`;
                    }
                }

                if (_config.type === 'GET' && send !== '') {
                    _config.url += `?${send}`;
                    send = '';
                }
            } else {
                send = _config.formData
            }

            // Headers
            request.open(_config.type, _config.url, true);
            request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
            if (_config.formData === undefined) {
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            }
            // Send
            request.send(send);
        });
    }

    /**
     * Get
     * @param url
     * @param data
     * @param json
     * @return {Promise}
     */
    get(url, data, json = true) {
        data = data || {};
        return this.ajax({url: url, type: 'GET', data: data, json: json});
    }

    /**
     * Post
     * @param url
     * @param data
     * @param json
     * @return {Promise}
     */
    post(url, data, json = true) {
        data = data || {};
        return this.ajax({url: url, type: 'POST', data: data, json: json});
    }

    /**
     * Put
     * @param url
     * @param data
     * @param json
     * @return {Promise}
     */
    put(url, data, json = true) {
        data = data || {};
        return this.ajax({url: url, type: 'PUT', data: data, json: json});
    }

    /**
     * Delete
     * @param url
     * @param data
     * @param json
     * @return {Promise}
     */
    delete(url, data, json = true) {
        data = data || {};
        return this.ajax({url: url, type: 'DELETE', data: data, json: json});
    }
}

module.exports = Http;